import PropTypes from 'prop-types';
import Icon from './Icon';

const Mobile = ({ stroke, strokeWidth, ...rest }) => (
  <Icon
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...rest}
    path="M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V22C19 23.1046 18.1046 24 17 24H7C5.89543 24 5 23.1046 5 22V5Z"
  >
    <path
      d="M9 21H15"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default Mobile;

Mobile.propTypes = {
  stroke: PropTypes.string.isRequired,
  strokeWidth: PropTypes.string.isRequired
};
